import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 Match Israel</p>
    </footer>
  );
};

export default Footer;
